import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-campaign-breadcrumb',
  templateUrl: './campaign-breadcrumb.component.html',
  styleUrls: ['./campaign-breadcrumb.component.css']
})
export class CampaignBreadcrumbComponent implements OnInit {
  @Input() stateAction: number;
  @Input() messageInstanceId: number;
  @Input() campaignId: number;
  @Input() actionId: number;
  @Input() actualStep: string;
  @Input() actionTypeCode: string;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  goToEmission() {
    this.router.navigate([`campaign-coupon-emission-setup/${this.campaignId}/${this.actionId}`, {
      actionTypeCode: this.actionTypeCode
    }]);
  }

  goToParameters() {
    this.router.navigate(['campaign-coupon-parameters-setup/' + this.messageInstanceId, {
      actionTypeCode: this.actionTypeCode
    }]);
  }

  goToFruition() {
    this.router.navigate(['campaign-coupon-fruition-setup/' + this.messageInstanceId + '/' + this.actionId, {
      actionTypeCode: 'CPN'
    }]);
  }

  goToLayout() {
    this.router.navigate(['campaign-coupon-layout-setup/' + this.messageInstanceId + '/' + this.actionId, {
      actionTypeCode: this.actionTypeCode
    }]);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-breadcrumb/campaign-breadcrumb.component.ts